import { DataField } from "@iventis/domain-model/model/dataField";
import { DataFieldType } from "@iventis/domain-model/model/dataFieldType";
import { StyleType } from "@iventis/domain-model/model/styleType";
import { EMPTY_GUID } from "@iventis/utilities";
import { createStaticStyleValue } from "@iventis/layer-style-helpers";
import { LayerDrawingControl, LayerStorageScope, MapModuleLayer } from "../types/store-schema";
import { TestingModelId } from "./map-testing.helpers";

export const dataFields: DataField[] = [
    {
        id: "fafec694-d0ce-4a8b-9a95-7d85938231bd",
        name: "Zones",
        type: DataFieldType.List,
        listValues: [
            {
                id: "29109773-9733-441c-9ea3-abdbedcc0cda",
                name: "Zone 1",
                order: 0,
                customerIdentifier: null,
                metaData: null,
                propertyValues: [],
                dataFieldId: undefined,
                uniqueId: undefined,
                externalReference: undefined,
                relationshipValues: [],
            },
            {
                id: "e823a7ed-c618-4017-b2c3-902dd3eaa0ee",
                name: "Zone 2",
                order: 0,
                customerIdentifier: null,
                metaData: null,
                propertyValues: [],
                dataFieldId: undefined,
                uniqueId: undefined,
                externalReference: undefined,
                relationshipValues: [],
            },
        ],
        projectId: null,
        showInApi: null,
        allowedMetadataProperties: null,
        apiNamePlural: null,
        apiNameSingular: null,
        customerIdentifierName: null,
        hierarchyMetadataPropertyName: null,
        listItemProperties: [],
        listItemRelationships: [],
        order: 0,
        deprecated: false,
        defaultValue: {
            valueText: undefined,
            dataFieldId: undefined,
            listItemId: undefined,
            valueDate: undefined,
            valueNumber: undefined,
            valueTickbox: undefined,
            valueRepeatedTimeRanges: undefined,
        },
    },
    {
        id: "997a9dda-c041-44e7-8c3b-21f1049abecf",
        name: "Text Literal",
        type: DataFieldType.Text,
        listValues: null,
        projectId: null,
        showInApi: null,
        allowedMetadataProperties: null,
        apiNamePlural: null,
        apiNameSingular: null,
        customerIdentifierName: null,
        hierarchyMetadataPropertyName: null,
        listItemProperties: [],
        listItemRelationships: [],
        order: 0,
        deprecated: false,
        defaultValue: {
            valueText: undefined,
            dataFieldId: undefined,
            listItemId: undefined,
            valueDate: undefined,
            valueNumber: undefined,
            valueTickbox: undefined,
            valueRepeatedTimeRanges: undefined,
        },
    },
];

const MODEL_LAYER_ID = "model-layer";

export const basicModelLayer: MapModuleLayer = {
    id: MODEL_LAYER_ID,
    name: null,
    visible: true,
    locked: false,
    storageScope: LayerStorageScope.LocalOnly,
    styleType: StyleType.Model,
    areaStyle: null,
    lineStyle: null,
    lineModelStyle: null,
    modelStyle: {
        styleType: StyleType.Model,
        model: createStaticStyleValue(TestingModelId.SchoolBus),
        scale: createStaticStyleValue(200),
        height: createStaticStyleValue(1),
        width: createStaticStyleValue(1),
        length: createStaticStyleValue(1),
        objectOrder: createStaticStyleValue(0),
        customImage: createStaticStyleValue(EMPTY_GUID),
        customColour: createStaticStyleValue(false),
        colour: createStaticStyleValue("#000000"),
        modelAltitude: createStaticStyleValue(0),
    },
    iconStyle: null,
    pointStyle: null,
    areaModelStyle: null,
    dataFields,
    source: MODEL_LAYER_ID,
    stamp: "",
    selected: false,
    drawingControls: {
        [LayerDrawingControl.ROTATION_HANDLE]: true,
        [LayerDrawingControl.MID_POINT_HANDLE]: false,
        [LayerDrawingControl.COORDINATE_HANDLE]: false,
    },
};
